<template>
	<figure class="broker-logo">
		<img :src="brokerLogo">
	</figure>
</template>

<script>
import pageFunctionsMixin from '../../mixins/pageFunctionsMixin';
import pluskaLogo from '@/assets/img/logo/pluska-logo.svg';
import universalLogo from '@/assets/img/logo/universal-logo.png';
import universalLogoWhite from '@/assets/img/logo/universal-logo-white.png';

	export default {
		name: "BrokerLogo",
		mixins: [pageFunctionsMixin],
		computed: {
			brokerLogo(){
				if (this.$store.state.app.appType === 'pluska'){
					return pluskaLogo;
				}

				let url = universalLogo;
				if (this.$store.state.app.darkMode){
					url = universalLogoWhite;
				}

				if (this.$store.state.auth.user.agent && this.$store.state.auth.user.agent.broker_data){
					url = this.$store.state.auth.user.agent.broker_data.broker_logo;
					if(this.$store.state.auth.user.agent.broker_data?.colors_ufo?.third){
						let colorStyle = this.getColorStyle(this.$store.state.auth.user.agent.broker_data.colors_ufo.third);
						if(colorStyle === 'light' && this.$store.state.auth.user.agent.broker_data.broker_logo2){
							url = this.$store.state.auth.user.agent.broker_data.broker_logo2;
						}
					}

					if (!this.$store.state.app.darkMode && this.$store.state.auth.user.agent.broker_data.broker_logo2){
						url = this.$store.state.auth.user.agent.broker_data.broker_logo2;
					}
				}

				return url;
			}
		}
	}
</script>

<style scoped lang="scss">
	.broker-logo {
		img {
			max-height: 50px;
		}
	}
</style>